import { Box, TextField } from "@mui/material";
import { useFormikContext } from "formik";
import { AddSolutionFormValues } from "../../types";

function CoordinatesInput() {
  const context = useFormikContext<AddSolutionFormValues>();

  return (
    <Box
      sx={{
        display: "flex",
        direction: "row",
      }}
    >
      <TextField
        id="latitude"
        fullWidth
        variant="standard"
        label="Latitude"
        sx={{ paddingRight: 2 }}
        onChange={context.handleChange}
        value={context.values["latitude"]}
        error={
          context.touched["latitude"] && Boolean(context.errors["latitude"])
        }
        helperText={context.touched["latitude"] && context.errors["latitude"]}
      />
      <TextField
        id="longitude"
        fullWidth
        variant="standard"
        label="Longitude"
        onChange={context.handleChange}
        value={context.values["longitude"]}
        error={
          context.touched["longitude"] && Boolean(context.errors["longitude"])
        }
        helperText={context.touched["longitude"] && context.errors["longitude"]}
      />
    </Box>
  );
}

export default CoordinatesInput;
